import * as core from './core';
import * as enums from './enums';
import * as adminCommon from './admin/common';
import * as desk from './admin/desk';
import * as deskActions from './admin/deskActions';
import * as members from './admin/members';
import * as memberImport from './admin/memberImport';
import * as segments from './admin/segments';
import * as access from './admin/access';
import * as sales from './admin/sales';
import * as classes from './admin/classes';
import * as payments from './admin/payments';
import * as finance from './admin/finance';
import * as website from './admin/website';
import * as websiteBlocks from './admin/websiteBlocks';
import * as gym from './admin/gym';
import * as team from './admin/team';
import * as leave from './admin/leave';
import * as timesheets from './admin/timesheets';
import * as shifts from './admin/shifts';
import * as receipt from './receipt';
import * as deadlines from './admin/deadlines';
import * as branches from './admin/branches';
import * as networks from './admin/networks';
import * as wallet from './admin/wallet';
import * as bar from './admin/bar';
import * as dashboards from './admin/dashboards';
import * as memberHome from './memberHome';
import * as memberClasses from './memberClasses';
import * as trainerPage from './trainerPage';
import * as addresses from './addresses';
import * as campaigns from './campaigns';
import * as leads from './admin/leads';
import * as targets from './admin/targets';
import * as expenses from './admin/expenses';
import * as appointments from './appointments';
import * as equipment from './admin/equipment';
import * as knowledge from './admin/knowledge';
import * as purchasing from './admin/purchasing';
import * as tasks from './admin/tasks';
import * as checklists from './admin/onboarding';
import * as recognition from './admin/recognition';
import * as recruiting from './admin/recruiting';
import * as corporate from './admin/corporate';
import * as apiAccess from './admin/apiAccess';
import * as notices from './notices';
import * as permissions from './admin/permissions';
import * as celebrations from './celebrations';
import * as employeeDocuments from './admin/employeeDocuments';
import * as reviews from './admin/reviews';
import * as peopleReport from './admin/peopleReport';
import * as appointmentsReport from './admin/appointmentsReport';
import * as duty from './admin/duty';
import * as siteDesign from './siteDesign';

/** Every area's English and Georgian messages. Each area types its Georgian half against its English half, so a key missing in either language fails to compile. */
export const areas = { core, enums, adminCommon, desk, deskActions, members, memberImport, segments, access, sales, classes, payments, finance, website, websiteBlocks, gym, team, leave, timesheets, shifts, receipt, deadlines, branches, networks, wallet, bar, dashboards, memberHome, memberClasses, trainerPage, addresses, campaigns, leads, targets, appointments, equipment, expenses, knowledge, tasks, checklists, purchasing, recognition, recruiting, corporate, apiAccess, notices, permissions, celebrations, employeeDocuments, duty, reviews, peopleReport, appointmentsReport, siteDesign };

const en = {
  ...core.en,
  ...enums.en,
  ...adminCommon.en,
  ...desk.en,
  ...deskActions.en,
  ...members.en,
  ...memberImport.en,
  ...segments.en,
  ...access.en,
  ...sales.en,
  ...classes.en,
  ...payments.en,
  ...finance.en,
  ...website.en,
  ...websiteBlocks.en,
  ...gym.en,
  ...team.en,
  ...leave.en,
  ...timesheets.en,
  ...shifts.en,
  ...receipt.en,
  ...deadlines.en,
  ...branches.en,
  ...networks.en,
  ...wallet.en,
  ...bar.en,
  ...dashboards.en,
  ...memberHome.en,
  ...memberClasses.en,
  ...trainerPage.en,
  ...addresses.en,
  ...campaigns.en,
  ...leads.en,
  ...targets.en,
  ...expenses.en,
  ...appointments.en,
  ...equipment.en,
  ...knowledge.en,
  ...purchasing.en,
  ...tasks.en,
  ...checklists.en,
  ...recognition.en,
  ...recruiting.en,
  ...corporate.en,
  ...apiAccess.en,
  ...notices.en,
  ...permissions.en,
  ...celebrations.en,
  ...employeeDocuments.en,
  ...reviews.en,
  ...peopleReport.en,
  ...appointmentsReport.en,
  ...duty.en,
  ...siteDesign.en,
};

export type MessageKey = keyof typeof en;

const ka: Record<MessageKey, string> = {
  ...core.ka,
  ...enums.ka,
  ...adminCommon.ka,
  ...desk.ka,
  ...deskActions.ka,
  ...members.ka,
  ...memberImport.ka,
  ...segments.ka,
  ...access.ka,
  ...sales.ka,
  ...classes.ka,
  ...payments.ka,
  ...finance.ka,
  ...website.ka,
  ...websiteBlocks.ka,
  ...gym.ka,
  ...team.ka,
  ...leave.ka,
  ...timesheets.ka,
  ...shifts.ka,
  ...receipt.ka,
  ...deadlines.ka,
  ...branches.ka,
  ...networks.ka,
  ...wallet.ka,
  ...bar.ka,
  ...dashboards.ka,
  ...memberHome.ka,
  ...memberClasses.ka,
  ...trainerPage.ka,
  ...addresses.ka,
  ...campaigns.ka,
  ...leads.ka,
  ...targets.ka,
  ...expenses.ka,
  ...appointments.ka,
  ...equipment.ka,
  ...knowledge.ka,
  ...purchasing.ka,
  ...tasks.ka,
  ...checklists.ka,
  ...recognition.ka,
  ...recruiting.ka,
  ...corporate.ka,
  ...apiAccess.ka,
  ...notices.ka,
  ...permissions.ka,
  ...celebrations.ka,
  ...employeeDocuments.ka,
  ...reviews.ka,
  ...peopleReport.ka,
  ...appointmentsReport.ka,
  ...duty.ka,
  ...siteDesign.ka,
};

export const dictionaries: Record<'en' | 'ka', Record<MessageKey, string>> = { en, ka };

export type PluralKey = { [K in MessageKey]: K extends `${infer Base}.other` ? Base : never }[MessageKey];

export type EnumKind = { [K in MessageKey]: K extends `enum.${infer Kind}.${string}` ? Kind : never }[MessageKey];
